import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  FetchWarehouseMemberAccessActions as Actions,
  FetchWarehouseMemberAccessRequestAction as RequestAction,
} from 'store/ducks/warehouseMemberAccesses';

export function* fetchWarehouseMemberAccessRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.get, `warehouse-member-accesses/${id}`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
